import TWalkthroughRoutingUserGroup from './index.vue';

TWalkthroughRoutingUserGroup.install = app => {
  app.component(TWalkthroughRoutingUserGroup.name, TWalkthroughRoutingUserGroup);
};

export default TWalkthroughRoutingUserGroup;
